module.exports = __webpack_public_path__ + "grabu.png?a03a2c03f61e5f84284a7aec61f02723";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grabu.png
// module id = 16
// module chunks = 0